export default "/images/38f7dd8d7613acade19a7d2065c22de1.avif";